import React from 'react';
import { Form, Button, Table, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { isBrowser } from 'react-device-detect';

import 'rc-tree/assets/index.css';
import Tree, { TreeNode } from 'rc-tree';

import SortTable from '../../components/SortTable';
import { I18n } from '../../utils/I18n';
import AlertDialog from '../../utils/AlertDialog';

import UserProtocol from '../../net/UserProtocol';

/*eslint eqeqeq: "off"*/

const Columns = {
  UserID: 0,
  UserName: 1,
  Organize: 2,
  Part: 3,
  Permission: 4,
  EMail: 5,
  State: 6
};

let defaultChecked = "0";

const root = process.env.PUBLIC_URL + "/";

export default class UserListPage extends React.Component {
  constructor(props) {
    super(props);

    // this.CompanyTreeComponent = (<div></div>);
    this.CompanyNewTreeComponent = (<div></div>);

    this.state = {

      CompanyNewTree: null,
      GroupCount: 0,
      BrandCount: 0,
      StoreCount: 0,
      ShowCompanyTree: true,
      value: "0",
      StatusValue:"Normal",

      UserList: [],
      AdminCount: 0,
      EditorCount: 0,
      ViewerCount: 0,
      UserRole: 0,

      VisibleColumn: [true, true, true, true, true, true, true],
      SearchBarValue: "",
      showTreeModal: false,
      AccountStr: "",
      PasswordStr: "",
      ConfirmPsdStr: "",
      EmailStr: "",
      NameStr: "",

      EditUserAccount: "",
      EditUserPassword: "",
      EditUserDisplayName: "",
      EditUserEmail: "",
      EditUserPhone: "",
      EditUserRoleId: 0,

      AuthoritieCheckBoxArray: [],

      NowSelectCompanyID:0,

      NowEditUserID: "",
      NowDeleteUserID: "",

      showEditModal: false,
      showDeleteModal: false,

      hover: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.handleStatusSubmit = this.handleStatusSubmit.bind(this);

    this.UserListTableRef = React.createRef();
    console.log('create user list page');
  }

  componentDidMount() {
    // 起始左邊樹資料
    fetch("/api/company/subsidiary", { credentials: 'include' })
      .then(res => res.json())
      .then(
        (result) => {
          console.log("arraylize:::::::::::::::::")
          console.log([result.data]);
          this.setState({ CompanyNewTree: [result.data] });
          this.setState({NowSelectCompanyID:[result.data][0].id});
          
          this.initNewCompanyTree(this.state.CompanyNewTree);
        },
        (error) => {
          console.log("error in UserList company data:", error)
        }
      );
        // 權限RoleID清單
      fetch("/api/company/permission/role/list", { credentials: 'include' })
      .then(res => res.json())
      .then(
        (result) => {
          console.log('現在開始拿role list:::');
          this.setState({ AuthoritieCheckBoxArray: result.data });
          // console.log(this.state.AuthoritieCheckBoxArray);
        },
        (error) => {
          console.log("role list錯誤:", error);
        }
      );
    // 起始右邊SortTable資料
    fetch("/api/company/account", { credentials: 'include' })
      .then(res => res.json())
      .then(
        (result) => {
          console.log('現在開始拿公司帳號資料:::');
          console.log(result)

          let UserNewArray = [];
          result.data.forEach(element => {
            let emptyUserArray = [];

            let RoleToBePush="";
            this.state.AuthoritieCheckBoxArray.forEach(
              role => {if (role.id === element.roleId){
                RoleToBePush=role.name;
              }
              }
            )
            if (RoleToBePush==""){ RoleToBePush=I18n.t('userListPage.permis.void')};
            
            emptyUserArray = [element.id, element.name, "組織資料", "部門",RoleToBePush, element.email, element.status];
            UserNewArray.push(emptyUserArray);
          });
          this.initUserList(UserNewArray);
        },
        (error) => {
          console.log("error in UserList:", error)
        }
      );

    // componentDidMount結束
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({ [name]: value });
  }

  toggleHover = () => {
    this.setState({ hover: !this.state.hover })
  };

// 原始拖拉Function開始
  onDrop = (info) => {
    const dragKey = info.dragNode.props.eventKey; //移動者
    const dropKey = info.node.props.eventKey; //目標位置
    //const dropPos = info.node.props.pos.split('-');
    //const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]); //新位置在目標位置的上中下哪個位置

    const dragItemKeys = dragKey.split("_");
    const dropItemKeys = dropKey.split("_");
    const dragItemLevel = dragItemKeys.length;
    const dropItemLevel = dropItemKeys.length;

    if (dragItemLevel < 2) { //移動的是集團
      return;
    }
    if (dragItemLevel !== dropItemLevel &&
      dragItemLevel - 1 !== dropItemLevel) {  //目標位置層級必須與移動者相同或者是移動者的上一層
      return;
    }
    if (dragItemLevel === 2) { //移動的是品牌
      if (dragItemKeys[0] === dropItemKeys[0]) { //目的地集團跟原集團是同一個
        return;
      }
    }
    if (dragItemLevel === 3) {  //移動的是分店
      if (dragItemKeys[0] === dropItemKeys[0] &&
        dragItemKeys[1] === dropItemKeys[1]) { //目的地品牌跟原品牌是同一個
        return;
      }
    }

    const findGroup = (data, groupid, callback) => {
      data.forEach((item, index, arr) => {
        if (item.GroupId == groupid) {
          callback(item, index, arr);
          return;
        }
      });
    }
    const findBrand = (data, groupid, brandid, callback) => {
      let group = null;
      findGroup(data, groupid, (item, index, arr) => {
        group = item;
      });
      if (group !== null) {
        group.Brand.forEach((item, index, arr) => {
          if (item.BrandId == brandid) {
            callback(item, index, arr);
            return;
          }
        });
      }
    }
    const findStore = (data, groupid, brandid, storeid, callback) => {
      let brand = null;
      findBrand(data, groupid, brandid, (item, index, arr) => {
        brand = item;
      });
      if (brand !== null) {
        brand.Store.forEach((item, index, arr) => {
          if (item.StoreId == storeid) {
            callback(item, index, arr);
            return;
          }
        });
      }
    }

    let CompanyTree = this.state.CompanyNewTree;
    //開始移動位置
    if (dragItemLevel === 2) { //移動的是品牌
      let dragBrand;
      findBrand(CompanyTree, dragItemKeys[0], dragItemKeys[1], (item, index, arr) => {
        arr.splice(index, 1);
        dragBrand = item;
      });
      findGroup(CompanyTree, dropItemKeys[0], (item, index, arr) => {
        item.Brand.push(dragBrand);
      });
    } else {  //移動的是分店
      let dragStore;
      findStore(CompanyTree, dragItemKeys[0], dragItemKeys[1], dragItemKeys[2], (item, index, arr) => {
        arr.splice(index, 1);
        dragStore = item;
      });
      findBrand(CompanyTree, dropItemKeys[0], dropItemKeys[1], (item, index, arr) => {
        item.Store.push(dragStore);
      });
    }

    console.log("drag done.");
    this.initNewCompanyTree(CompanyTree);
  }
// 原始拖拉Function結束

  handleSelectSyn = () => {
    let node = [];
    this.state.AuthoritieCheckBoxArray.forEach(element =>
      node.push(<option value={element.id}>{element.name}</option>)
    )
    return (node)
  }




// 左邊樹呈現
  initNewCompanyTree(CompanyTree) {
    let GroupCount = 0;
    let BrandCount = 0;
    let StoreCount = 0;

    this.CompanyNewTreeComponent = (
      <div style={{ height: "100%", overflowY: "auto" }}>
        <Tree defaultExpandAll={true} showIcon={false} showLine={true}
          draggable={true} onDrop={this.onDrop}
        onClick={(e, node) => {
         
          this.setState({NowSelectCompanyID:node.props.eventKey});
          this.UserListTableRef.current.deleteAccountCheckBox();    

      fetch("/api/company/"+node.props.eventKey.toString() +"/account",{credentials: 'include'})
      .then(res => res.json())
      .then(
        (result) => {

    // this.setState({ CompanyNewTree: [result.data] });
    // this.initNewCompanyTree(this.state.CompanyNewTree);
    // CompanyTree = this.state.CompanyNewTree;

    let UserNewArray = [];
    result.data.forEach(element => {
      let emptyUserArray = [];

      let RoleToBePush="";
      this.state.AuthoritieCheckBoxArray.forEach(
        role => {if (role.id === element.roleId){
          RoleToBePush=role.name;
        }
        }
      )
      if (RoleToBePush==""){ RoleToBePush=I18n.t('userListPage.permis.void')};
      
      emptyUserArray = [element.id, element.name, "組織資料", "部門",RoleToBePush, element.email, element.status];
      UserNewArray.push(emptyUserArray);
    });
    this.initUserList(UserNewArray);


        },
        (error) => {
        console.log("error in click company Tree:",error)
        }
      )
        }}
        >
          {
            this.state.CompanyNewTree.map((group) => {
              GroupCount++;
              return <TreeNode key={group.id} title={group.name}>
                {
                  group.subsidiaries.map((brand) => {
                    BrandCount++;
                    return <TreeNode key={brand.id} title={brand.name}>
                      {
                        brand.subsidiaries.map((store) => {
                          StoreCount++;
                          return <TreeNode key={store.id} title={store.name} />
                        })
                      }
                    </TreeNode>
                  })
                }
              </TreeNode>
            })
          }
        </Tree>
      </div>
    );

    this.setState({
      CompanyTree,
      GroupCount,
      BrandCount,
      StoreCount
    });

  };
// 左邊樹結束

// 整理資料以塞進Sortable
  initUserList(UserListData) {
    let AdminCount = 0;
    let EditorCount = 0;
    let ViewerCount = 0;

    let UserList = [];

    UserListData.map((userData) => {
      let userId = userData[0];
      let user = [userId, userData[1], userData[2], userData[3], userData[4], userData[5], userData[6]];

      switch (user[Columns.State]) {
        case "Locked":
          user[Columns.State] = <span className="text-danger">{I18n.t("userListPage.state.disable")}</span>
          break;
        case "FailLoginLimit":
          user[Columns.State] = I18n.t("userListPage.state.review");
          break;
        case "Normal":
          user[Columns.State] = <span className="text-success">{I18n.t("userListPage.state.enable")}</span>
          break;
        default:
          break;
      }

      UserList.push(user);
      return 0;
    });

    this.setState({
      UserList,
      AdminCount,
      EditorCount,
      ViewerCount
    }, () => {
      this.UserListTableRef.current.SortRows(0, true);
    });
  };

  handleChange(event) {
    this.setState({ value: event.target.value });
    defaultChecked = event.target.value;

  }

  handleStatusChange(event) {
    this.setState({ StatusValue: event.target.value });
    // alert(event.target.value)
  }


  handleStatusSubmit(event){
    // alert(this.state.StatusValue)
    console.log("狀態提交::");
    let defaultCheckedArray=[];
    defaultCheckedArray=this.UserListTableRef.current.getAccountCheckBox();
    let defaultCheckedSet= new Set();
    for (let i = 0; i < defaultCheckedArray.length; i++)
    {
      defaultCheckedSet.add(defaultCheckedArray[i])
    };
    let setToArray=[];
    for(let checkbox of defaultCheckedSet.values()){
      if(checkbox!=null){
        if (checkbox.checked==true){
          setToArray.push(true)
        }else{ setToArray.push(false); }
           } 
    }
    let UserIDArray = [];
    defaultCheckedSet.forEach(item => {
      if (item != null){
      UserIDArray.push(item.name)
      }
    })
    event.preventDefault();
    
    console.log(this.state.StatusValue);

    for (let i = 0; i < UserIDArray.length; i++){
      if (setToArray[i]==true)
      { 
        console.log(UserIDArray[i]);
    fetch("/api/company/account/"+UserIDArray[i],
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "PUT",
      body: JSON.stringify({
        "status": this.state.StatusValue
      })
    })
    .then(function (res) { console.log(res) })
    .catch(function (res) { console.log(res) });

    let  RenewRay=[];
    RenewRay  =this.state.UserList;


    RenewRay.forEach(element => {
        if (element[0]==UserIDArray[i]){

        switch (this.state.StatusValue ) {
          case "Locked":
            element[6] = <span className="text-danger">{I18n.t("userListPage.state.disable")}</span>
            break;
          case "FailLoginLimit":
            element[6] = I18n.t("userListPage.state.review");
            break;
          case "Normal":
            element[6] = <span className="text-success">{I18n.t("userListPage.state.enable")}</span>
            break;
          default:
            break;
        }
          
        }
      })

      this.setState({UserList:RenewRay});  
  
  }
  }
  }

  handleSubmit(event) {
    console.log("現在提交::")
    let defaultCheckedArray=[];
    defaultCheckedArray=this.UserListTableRef.current.getAccountCheckBox();
    let defaultCheckedSet= new Set();
    console.log(defaultCheckedArray.length)
    for (let i = 0; i < defaultCheckedArray.length; i++)
    {
      defaultCheckedSet.add(defaultCheckedArray[i])
    };
    let setToArray=[];
    for(let checkbox of defaultCheckedSet.values()){
      if(checkbox!=null){
        if (checkbox.checked==true){
          setToArray.push(true)
        }else{ setToArray.push(false); }
           } 
    }
    
    let UserIDArray = [];
    defaultCheckedSet.forEach(item => {
      if (item != null){
        UserIDArray.push(item.name)
      }

    })
    event.preventDefault();

    // console.log(this.state.value);

    console.log(this.state.AuthoritieCheckBoxArray);

    // this.state.AuthoritieCheckBoxArray.forEach(element=>{
    //   console.log(element);})
    // console.log(this.state.UserList);

    for (let t = 0; t < UserIDArray.length; t++){
      if (setToArray[t]==true)
      { 
        console.log(UserIDArray[t]);
    fetch("/api/company/account/"+UserIDArray[t],
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "PUT",
      body: JSON.stringify({
        "roleId": this.state.value
      })
    })
    .then(function (res) { console.log(res) })
    .catch(function (res) { console.log(res) });


    let  RenewRay=[];
    RenewRay  =this.state.UserList;

    RenewRay.forEach(element => {
        if (element[0]==UserIDArray[t]){
          this.state.AuthoritieCheckBoxArray.forEach(Role => {
            if (Role.id ==this.state.value){
              element[4]=Role.name;   
             }
             if (this.state.value == 0){
              element[4]=I18n.t("userListPage.permis.void");
             }
             
          })
        }
      })


      this.setState({UserList:RenewRay});   
      }
    }
    
  }


  handleSearchInputChange(e) {
    this.setState({ SearchBarValue: e.target.value });
    let NewUserList = [];
    this.state.UserList.forEach((user) => { 
     if ( user[1].includes(e.target.value) ){
      NewUserList.push(user);
     }
     })
     console.log(NewUserList);

    this.UserListTableRef.current.updateRow(NewUserList);
  }


  handleRoleOption = () => {
    let node = [];
    this.state.AuthoritieCheckBoxArray.forEach(element =>
      node.push(<option value={element.id}>{element.name}</option>)
    )
    return (node)
  }




  render() {
    return (
      <div className="d-flex align-items-end flex-column" style={{ height: "94vh", paddingTop: "20px", paddingLeft: "2%", paddingRight: "2%", paddingBottom: "0px" }}>
        <div className="d-flex flex-row align-items-center w-100">
          <h4><b><u><FormattedMessage id="mainPage.users.list" /></u></b></h4>
          <button className="border border-secondary text-primary"
            onClick={() => {
              this.setState({ showTreeModal: true });
            }}
            style={{ backgroundColor: '#fff', marginLeft: "1%", paddingLeft: "10px", paddingRight: "10px" }}>
            <b><FormattedMessage id="mainPage.users.create" /></b></button>
        </div>
        <div className="clearfix w-100" style={{ marginTop: "20px" }}>
          <div className="float-left d-flex flex-row" style={{ width: (isBrowser ? "70%" : "100%") }}>
            <Form.Group controlId="contrlSelect"   >
              <Form.Control size="sm" as="select" value={this.state.StatusValue}  onChange={this.handleStatusChange}>
                <option value="Normal">{I18n.t("userListPage.state.enable")}</option>
                <option value="Locked">{I18n.t("userListPage.state.disable")}</option>
                {/* <option value="FailLoginLimit">{I18n.t("userListPage.state.review")}</option> */}
                
              </Form.Control>
            </Form.Group>
            <Button variant="outline-dark" className="h-100" size="sm"
              style={{ marginLeft: "5px", backgroundImage: "url('" + root + "images/button_bg.png')", backgroundSize: "100% 100%", borderWidth: "0px", backgroundColor: "rgba(0,0,0,0)" }}
              onClick={this.handleStatusSubmit}
            >
              <FormattedMessage id="global.use" /></Button>

            <Form.Group controlId="permissionSelect" style={{ marginLeft: "2%" }} onSubmit={this.handleSubmit} >
              <Form.Control size="sm" as="select" value={this.state.value} onChange={this.handleChange} >

                <option value={0}>{I18n.t("userListPage.permis.void")}</option>
                {this.handleSelectSyn()}

              </Form.Control>
            </Form.Group>
            <Button variant="outline-dark" className="h-100" size="sm"
              style={{ marginLeft: "5px", backgroundImage: "url('" + root + "images/button_bg.png')", backgroundSize: "100% 100%", borderWidth: "0px", backgroundColor: "rgba(0,0,0,0)" }}
              onClick={this.handleSubmit}
            >
              <FormattedMessage id="global.use" /></Button>
          </div>

          {/* 搜尋使用者 */}
          <div className="float-right row">
          <b>
          <FormattedMessage id="userListPage.searchUser" />
          </b>
            <Form.Group controlId="searchUser" className="float-left ml-2">
              <Form.Control className="input" type="text" size="sm" 
               value={this.state.SearchBarValue} 
              // value={"crtl + F 搜尋使用者"}
              onChange={this.handleSearchInputChange} />
            </Form.Group>

          </div>
        </div>
        <div className="mt-auto w-100" style={{ height: "75%" }}>
          {this.renderMainTable()}
        </div>
        <div className="mt-auto w-100 d-flex justify-content-end">
          {I18n.t('global.version', { version: 1.0 })}
        </div>
        {this.renderFooter()}

        {/* 新增使用者MODAL 開始 */}
        <Modal
          size="lg"
          aria-labelledby="example-modal-sizes-title-lg"
          centered
          show={this.state.showTreeModal} onHide={() => { this.setState({ showTreeModal: false }) }}>
          <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
            <Modal.Title style={{ color: "white", marginLeft: "40%" }}><FormattedMessage id="PermissionSetting.MainPage.CreateUser" /></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}><FormattedMessage id="createUser.account.title" /></span>
              <Form.Control type="text" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                placeholder={I18n.t("createUser.account.holder", { min: 6, max: 16 })}
                name="AccountStr"
                value={this.state.AccountStr} onChange={this.handleInputChange}
              />
            </div>
            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}><FormattedMessage id="createUser.password.title" /></span>
              <Form.Control type="password" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                placeholder={I18n.t("createUser.account.holder", { min: 6, max: 16 })}
                name="PasswordStr"
                value={this.state.PasswordStr} onChange={this.handleInputChange}
              />
            </div>
            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}><FormattedMessage id="createUser.password.title2" /></span>
              <Form.Control type="password" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                placeholder={I18n.t("createUser.account.holder", { min: 6, max: 16 })}
                name="ConfirmPsdStr"
                value={this.state.ConfirmPsdStr} onChange={this.handleInputChange}
              />
            </div>

            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}><FormattedMessage id="createUser.email.title" /></span>
              <Form.Control type="text" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                placeholder={I18n.t("createUser.email.holder")}
                name="EmailStr"
                value={this.state.EmailStr} onChange={this.handleInputChange}
              />
            </div>
            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}><FormattedMessage id="createUser.username.title" /></span>
              <Form.Control type="text" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                placeholder={I18n.t("createUser.username.holder")}
                name="NameStr"
                value={this.state.NameStr} onChange={this.handleInputChange}
              />
            </div>
            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}><FormattedMessage id="createUser.phone.title" /></span>
              <Form.Control type="text" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                placeholder={I18n.t("createUser.phone.holder")}
                name="PhoneStr"
                value={this.state.PhoneStr} onChange={this.handleInputChange}
              />
            </div>
            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}><FormattedMessage id="createUser.role.title" /></span>
              <Form.Control type="text" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                as="select"
                id="permissionSelect" name="UserRole"
                value={this.state.UserRole}
                onChange={this.handleInputChange}
              >
                <option value={0} >{I18n.t("userListPage.permis.void")}</option>
                {this.handleRoleOption()}
              </Form.Control>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary"
              style={{ marginRight: "30%" }}
              onClick={() => { this.setState({ showTreeModal: false }) }}>
              {I18n.t("global.cancel")}
            </Button>

            {/* 新增使用者按鈕點擊 */}

            <Button variant="primary"
              style={{ marginRight: "30%" }}
              onClick={() => {

                

                let AppendSortTable = (res) => {

                  let data = res.data;
                  // alert(JSON.stringify(data));
                  let UserArray = this.state.UserList;
                  let Rolelock = <span className="text-danger">{I18n.t("userListPage.state.disable")}</span>;
                  if (data.locked === true) {
                    Rolelock = <span className="text-success">{I18n.t("userListPage.state.enable")}</span>;
                  }
                  else {
                    Rolelock = <span className="text-danger">{I18n.t("userListPage.state.disable")}</span>;
                  }

                  UserArray.push([data.id, data.name, "組織資料", "部門", data.roleId, data.email, Rolelock]);
                  this.setState({ UserList: UserArray });
                };

                this.setState({ showTreeModal: false });
                const Accountregex = /^[A-Za-z0-9]{6,16}$/;

                if (!Accountregex.test(this.state.AccountStr)) {
                  AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.ReplyAccountstrError"));
                  console.log("新增使用者:帳號檢查錯誤");
                  return;
                };
                if (this.state.NameStr === "") {
                  AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.ReplyNamestrEmpty"));
                  console.log("新增使用者:姓名不能為空");
                  return;
                };

                const regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if (!regex.test(this.state.EmailStr)) {
                  AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.ReplyEmailstrEmpty"));
                  console.log("新增使用者:Email檢查異常");
                  return;
                };

                if (this.state.PasswordStr !== this.state.ConfirmPsdStr) {
                  AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.ReplyConfirmPsd"));
                  console.log("新增使用者:確認密碼與密碼不一致");
                  return;
                }
                const reg0 = /^\d{5,12}$/;
                if (!reg0.test(this.state.PhoneStr)) {
                  AlertDialog.show(I18n.t("msg.createUser.ReplyPost"), I18n.t("msg.createUser.PhoneNumCheck"));
                  console.log("新增使用者:電話檢查異常");
                  return;
                }

                fetch("/api/company/"+ this.state.NowSelectCompanyID.toString()+"/account",
                  {
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    method: "POST",
                    body: JSON.stringify({
                      "loginId": this.state.AccountStr,
                      "name": this.state.NameStr,
                      "password": this.state.PasswordStr,
                      // "newPassword": "新密碼",
                      "gender": null,
                      "phone": this.state.PhoneStr,
                      "email": this.state.EmailStr,
                      "roleId": this.state.UserRole
                    })
                  })
                  .then(
                    function (res) {
                      res.json().then(AppendSortTable.bind(this))
                    }
                  )
                  .catch(function (res) { console.log("新增使用者錯誤::", res) });
                  this.setState({AccountStr:""});
                  this.setState({NameStr:""});
                  this.setState({PasswordStr:""});
                  this.setState({PhoneStr:""});
                  this.setState({EmailStr:""});
                  this.setState({UserRole:0});
                  this.setState({ConfirmPsdStr:""});
              }}>
              {I18n.t("global.ok")}
            </Button>
          </Modal.Footer>
        </Modal>
        {/* 新增使用者MODAL 結束 */}

        {/* 編輯使用者MODAL 開始 */}

        <Modal
          show={this.state.showEditModal}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={() => { this.setState({ showEditModal: false }) }}
        >
          <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
            <Modal.Title id="contained-modal-title-vcenter"
              style={{ color: "white", marginLeft: "39%" }}
            >
              {I18n.t("userListPage.permis.EditRole")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}>{I18n.t("userListPage.UserAccount")}</span>
              <Form.Control type="text" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                name="EditUserAccount"
                defaultValue={this.state.EditUserAccount}
                value={this.state.EditUserAccount} onChange={this.handleInputChange}
              />
            </div>

            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}>{I18n.t("userListPage.UserPassword")}</span>
              <Form.Control type="password" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                name="EditUserPassword"
                value={this.state.EditUserPassword} onChange={this.handleInputChange}
              />
            </div>

            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}>{I18n.t("userListPage.UserDisplayName")}</span>
              <Form.Control type="text" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                name="EditUserDisplayName"
                defaultValue={this.state.EditUserDisplayName}
                value={this.state.EditUserDisplayName} onChange={this.handleInputChange}
              />
            </div>

            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}>{I18n.t("userListPage.UserEmail")}</span>
              <Form.Control type="text" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                name="EditUserEmail"
                value={this.state.EditUserEmail} onChange={this.handleInputChange}
              />
            </div>

            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}>{I18n.t("userListPage.UserPhone")}</span>
              <Form.Control type="text" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                name="EditUserPhone"
                value={this.state.EditUserPhone} onChange={this.handleInputChange}
              />
            </div>

            <div className="ml-5 mb-2 row" >
              <span style={{ width: "20%" }}><FormattedMessage id="createUser.role.title" /></span>
              <Form.Control type="text" size="sm"
                style={{ width: "60%", marginLeft: "10px" }}
                as="select"
                id="permissionSelect" name="EditUserRoleId"
                defaultValue={this.state.EditUserRoleId}
                value={this.state.EditUserRoleId}
                onChange={this.handleInputChange}
              >
                <option value={0} >{I18n.t("userListPage.permis.void")}</option>
                {this.handleRoleOption()}
              </Form.Control>
            </div>


          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary"
              style={{ marginRight: "30%" }}
              onClick={() => { this.setState({ showEditModal: false }) }}>
              {I18n.t("global.cancel")}
            </Button>
            <Button
              style={{ marginRight: "30%" }}
              onClick={() => {
               

              this.setState({ showEditModal: false })

              fetch("/api/company/account/"+this.state.NowEditUserID,
              {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                method: "PUT",
                body: JSON.stringify({
                  "loginId": this.state.EditUserAccount,
                  "name": this.state.EditUserDisplayName,
                  "password": this.state.EditUserPassword,
                  "phone": this.state.EditUserPhone,
                  "email": this.state.EditUserEmail,
                  "roleId": this.state.EditUserRoleId
                })
              })
              .then(function (res) { console.log(res) })
              .catch(function (res) { console.log(res) });

              let EditUserList=[];
              EditUserList=this.state.UserList;
              console.log("現在位置:")

              EditUserList.forEach(element=>{
                if (element[0] == this.state.NowEditUserID){
                  element[1]=this.state.EditUserDisplayName;

                  this.state.AuthoritieCheckBoxArray.forEach(role=>{
                    if (role.id ==this.state.EditUserRoleId){
                      element[3]=role.name;
                    }
                  })

                  
                  element[5]=this.state.EditUserEmail;
                }

              });

              this.setState({UserList:EditUserList});
              
              }}>{I18n.t("global.ok")}</Button>
          </Modal.Footer>
        </Modal>

        {/* 編輯使用者MODAL 結束 */}

        {/* 刪除使用者MODAL 開始 */}
        <Modal
          show={this.state.showDeleteModal}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={() => { this.setState({ showDeleteModal: false }) }}
        >
          <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
            <Modal.Title id="contained-modal-title-vcenter"
              style={{ color: "white", marginLeft: "39%" }}
            >
              {I18n.t("PermissionSetting.MainPage.DeleteUser")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <h3 style={{ marginTop: "20px", marginBottom: "20px", marginLeft: "33%" }}>
              {I18n.t("userListPage.AsureDelete")}</h3>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary"
              style={{ marginRight: "30%" }}
              onClick={() => { this.setState({ showDeleteModal: false }) }}>
              {I18n.t("global.cancel")}
            </Button>
            <Button
              style={{ marginRight: "30%" }}
              onClick={() => { 
                this.setState({ showDeleteModal: false });
                // alert(this.state.NowDeleteUserID);
                
                fetch("/api/company/account/"+this.state.NowDeleteUserID,{credentials: 'include'
                ,method: "DELETE"
              })
                .then(res => res.json())
                .then(
                  (result) => {
                    console.log(result);
                  },
                  (error) => {
                  console.log("error in delete role:",error)
                  }
                );
                let EditDelUserList=[];
                EditDelUserList=this.state.UserList;
                EditDelUserList.forEach((item, index, object) => {
                  if (item[0]== this.state.NowDeleteUserID){
                    object.splice(index,1)

                  }
                })

                this.setState({UserList:EditDelUserList});

                }}>{I18n.t("global.ok")}</Button>
          </Modal.Footer>
        </Modal>

        {/* 刪除使用者MODAL 結束 */}
      </div>
    );
  }

  renderMainTable() {
    return (
      <Table bordered size="sm" style={{ backgroundColor: "#fff", height: "100%" }}>
        <thead>
          <tr style={{ backgroundImage: "url('/images/bar_bg.png')", backgroundSize: "100% 100%" }}>
            {
              this.state.ShowCompanyTree ?
                <th style={{ width: "20%" }} className="text-primary">
                  <FormattedMessage id="userListPage.tree.group" values={{ count: this.state.GroupCount }} /><FormattedMessage id="userListPage.tree.split" />
                  <FormattedMessage id="userListPage.tree.brand" values={{ count: this.state.BrandCount }} /><FormattedMessage id="userListPage.tree.split" />
                  <FormattedMessage id="userListPage.tree.store" values={{ count: this.state.StoreCount }} />
                </th>
                : null
            }
            <th style={{ width: this.state.ShowCompanyTree ? "80%" : "100%" }} className="text-primary">
              <FormattedMessage id="userListPage.header.all" values={{ count: this.state.UserList.length }} /><FormattedMessage id="userListPage.header.split" />
              <FormattedMessage id="userListPage.header.manager" values={{ count: this.state.AdminCount }} /><FormattedMessage id="userListPage.header.split" />
              <FormattedMessage id="userListPage.header.editor" values={{ count: this.state.EditorCount }} /><FormattedMessage id="userListPage.header.split" />
              <FormattedMessage id="userListPage.header.viewer" values={{ count: this.state.ViewerCount }} />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {
              this.state.ShowCompanyTree ?
                <td style={{ padding: "0px" }}>
                  {this.CompanyNewTreeComponent}
                </td>
                : null
            }
            <td style={{ padding: "0px" }}>
              {this.renderUserListTable()}
            </td>
          </tr>
        </tbody>
      </Table>
    );
  }

  Editmodalshow = (userdata) => {
    // alert(userdata);
    this.setState({ showEditModal: true });
    this.setState({ NowEditUserID: userdata })

    fetch("/api/company/account/" + userdata, { credentials: 'include' })
      .then(res => res.json())
      .then(
        (result) => {
          console.log("get User Info:::")
          if (result.data.roleId == null) { this.setState({ EditUserRoleId: 0 }) }
          else { this.setState({ EditUserRoleId: result.data.roleId }) }
          this.setState({ EditUserAccount: result.data.loginId });
          this.setState({ EditUserDisplayName: result.data.name });
          this.setState({ EditUserPhone: result.data.phone });
          this.setState({ EditUserEmail:result.data.email});
        },
        (error) => {
          console.log("error in dashboard:", error)
        }
      )
  }

  Deletemodalshow = (userdata) => {
    this.setState({ showDeleteModal: true });
    this.setState({ NowDeleteUserID: userdata });

  }


  renderUserListTable() {
    let headers = [
      I18n.t('userListPage.table.userid'),
      I18n.t('userListPage.table.username'),
      I18n.t('userListPage.table.org'),
      I18n.t('userListPage.table.part'),
      I18n.t('userListPage.table.permit'),
      I18n.t('userListPage.table.email'),
      I18n.t('userListPage.table.state')
    ];

    return (
      <SortTable ref={this.UserListTableRef}
        Headers={headers}
        Rows={this.state.UserList}
        DefaultVisibleColumn={[true, true, true,false, true, true, true]}
        HasCheckBox={true}
        openEditModel={(userData) => { this.Editmodalshow(userData) }}
        openDeleteModel={(userData) => { this.Deletemodalshow(userData) }}
      />
    );
  }

  renderFooter() {
    return (
      <footer className="mt-auto w-100" style={{ borderLeft: "1px solid #ccc" }}>
        <div className="d-flex flex-row h-25" >
          <div style={{ backgroundColor: "#fff", borderTop: "1px solid #ccc", borderRight: "1px solid #ccc", paddingLeft: '10px', paddingRight: '10px' }}>
            <FormattedMessage id="userListPage.displayset" />
          </div>
          <div className="flex-fill" style={{ borderBottom: "1px solid #ccc" }} ></div>
        </div>
        <div className="h-75 p-2" style={{ backgroundColor: "#fff", borderRight: "1px solid #ccc" }}>
          <span style={{ marginLeft: "20px" }}><FormattedMessage id="userListPage.dpset.column" /></span>
          <div className="d-flex flex-wrap">
            <Form.Check type="checkbox" id="dpset.orgtree" label={I18n.t("userListPage.dpset.orgtree")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setState((prev) => ({ ShowCompanyTree: !prev.ShowCompanyTree }))} checked={this.state.ShowCompanyTree} />
            <Form.Check type="checkbox" id="dpset.userid" label={I18n.t("userListPage.table.userid")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setVisableColumn(Columns.UserID)} checked={this.state.VisibleColumn[Columns.UserID]} />
            <Form.Check type="checkbox" id="dpset.username" label={I18n.t("userListPage.table.username")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setVisableColumn(Columns.UserName)} checked={this.state.VisibleColumn[Columns.UserName]} />
            <Form.Check type="checkbox" id="dpset.org" label={I18n.t("userListPage.table.org")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setVisableColumn(Columns.Organize)} checked={this.state.VisibleColumn[Columns.Organize]} />
            {/* <Form.Check type="checkbox" id="dpset.part" label={I18n.t("userListPage.table.part")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setVisableColumn(Columns.Part)} checked={this.state.VisibleColumn[Columns.Part]} /> */}
            <Form.Check type="checkbox" id="dpset.permit" label={I18n.t("userListPage.table.permit")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setVisableColumn(Columns.Permission)} checked={this.state.VisibleColumn[Columns.Permission]} />
            <Form.Check type="checkbox" id="dpset.email" label={I18n.t("userListPage.table.email")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setVisableColumn(Columns.EMail)} checked={this.state.VisibleColumn[Columns.EMail]} />
            <Form.Check type="checkbox" id="dpset.state" label={I18n.t("userListPage.table.state")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setVisableColumn(Columns.State)} checked={this.state.VisibleColumn[Columns.State]} />
          </div>
        </div>


      </footer>
    );
  }

  setVisableColumn(column) {
    let VisibleColumn = this.state.VisibleColumn;
    VisibleColumn[column] = !VisibleColumn[column];
    this.UserListTableRef.current.toggleVisibleColumn(column);
    this.setState({
      VisibleColumn
    });
  }




}